<section class="title-bar content-padding first-item content-padding">
    <div class="wrapper">
        <!-- <h2 class="left">{{ priorityList?.id ? "Modifica" : "Nuovo"}} Partner Priority List</h2> -->
        <h2 class="left">Nuovo Product Priority List</h2>
        <br class="clear">
    </div>
</section>

<section class="content-padding darker">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="productPriorityListForm" *ngIf="productPriorityListForm" (ngSubmit)="onSubmit()">
            <div class="grid-element-full">
                <label style="position: relative; top: 20px;">Scegli Prodotto</label>
                <div>
                    <div class="offer-products">
                        <div class="" style="display: table; width: 100%;">
                            <label for=""></label>
                            <div style="display: table-cell; width: 19px;">
                                <i class="far fa-times-circle hvr-grow remove-product"></i>
                            </div>
                            <div class="product-q">
                                <div class="porduct-qty">
                                    <div class="province-input">
                                        <label for=""></label>
                                        <ng-select 
                                            formControlName="product"
                                            [searchable]="true" 
                                            [clearable]="true"
                                            [virtualScroll]="true"
                                            >
                                            <ng-option *ngFor="let product of products" [value]="product.id">
                                            {{ product?.name }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <app-error-html-handler [ctrl]="productPriorityListForm.get('product')" [messages]="formValidationMsgs.product"></app-error-html-handler>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-48 grid-element">
                <label style="position: relative; top: 20px;">Scegli la Provincia</label>
                <div>
                    <div class="offer-products">
                        <div class="" style="display: table; width: 100%;">
                            <label for=""></label>
                            <div style="display: table-cell; width: 19px;">
                                <i class="far fa-times-circle hvr-grow remove-product"></i>
                            </div>
                            <div class="product-q">
                                <div class="porduct-qty">
                                    <div class="province-input">
                                        <label for=""></label>
                                        <ng-select formControlName="province">
                                            <ng-option *ngFor="let province of provinces" [value]="province.id">
                                                <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <app-error-html-handler [ctrl]="productPriorityListForm.get('province')" [messages]="formValidationMsgs.province"></app-error-html-handler>
                        </div>
                    </div>
                </div>
            </div>

            <div class="center" style="margin-top: 10px;">
                <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!productPriorityListForm.valid">
                    Salva<i class="ml-10 far fa-save"></i>
                </button>
            </div>
            <!--
            <div class="center" style="margin-top: 10px;">
                <button type="button" [routerLink]="['/product/priority-list/duplica', priorityList?.id]" class="btn hvr-shrink center">
                    Duplica<i class="ml-10 far fa-save"></i>
                </button>
            </div>
            -->
        </form>
    </div>
</section>
    